import { OrderPaymentStatus } from "src/core/orders/api/orders.api";

/**
 * Converts an order status to a human descriptor
 */
export const orderPaymentStatusToHuman = (status: OrderPaymentStatus): string => {
  switch (status) {
    default:
    case OrderPaymentStatus.UNCAPTURED:
      return "pending";
    case OrderPaymentStatus.CAPTURED:
      return "paid";
    case OrderPaymentStatus.FAILED:
      return "failed";
    case OrderPaymentStatus.REFUND_FAILED:
      return "refund failed";
    case OrderPaymentStatus.CANCELED:
      return "canceled";
    case OrderPaymentStatus.REFUNDED:
      return "refunded";
    case OrderPaymentStatus.PARTIAL_REFUNDED:
      return "partially refunded";
  }
};
